import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../api/fetchJson'
import { useAuth } from './useAuth'
import { env } from '../config/env'

type Membership = { org_id: string; role: string; org_name?: string }

export function useDemoRole() {
  const { user, verifyState } = useAuth()
  return useQuery<Membership | null>({
    queryKey: ['my-memberships', user?.uid],
    enabled: verifyState === 'verified',
    staleTime: 60_000,
    queryFn: async () => {
      const list = await fetchData<Membership[]>('/api/users/me/organizations')
      const match = list.find((m) => m.org_id === env.demoOrgId)
      return match ?? null
    },
  })
}
